import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import headerArrowBack from '../../img/headerArrowBack.jpg';
import headerArrowBackMobile from "../../img/headerArrowBackMobile.png";
import {
  stepDirect,
  stepDecrement
} from '../../actions/step'

const lastStep = "lastStep";

class ClassHeader extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    this.props.step.pageNumber !== 0 ? this.props.stepDecrement() : this.props.stepDirect(0, "/");
  }
  render() {
    return (
      <div className={this.props.step.pageNumber === 6 ? lastStep+" headerBack" : "headerBack"} onClick={this.handleClick} >
      <div className='pictoArrow'>
            <img className='mobile' src={headerArrowBackMobile} alt={"Revenir à l\'étape précédente"}/>
            <img className='desktop' src={headerArrowBack} alt={"Revenir à l'étape précédente"}/>
            </div>
            <div className='texte fontBook'>
            { this.props.step.pageNumber === 0 ? 'Revenir à l’écran précédent':null}
            { this.props.step.pageNumber === 1 ? 'Revenir au choix du projet':null}
            { this.props.step.pageNumber === 2 ? 'Revenir aux informations personnelles':null}
            { this.props.step.pageNumber === 3 ? 'Revenir au choix du véhicule':null}
            { this.props.step.pageNumber === 4 ? 'Revenir au choix du distributeur':null}
            { this.props.step.pageNumber === 6 ? 'Revenir au detail du rendez-vous':null}
            </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      stepDecrement,
      stepDirect
    },
    dispatch
  );

export const Header = connect(mapStateToProps, mapDispatchToProps)(
  ClassHeader
);



// WEBPACK FOOTER //
// ./src/containers/components/Header.js